import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, message } from 'antd';
import { push } from 'connected-react-router';
import { FormattedMessage } from 'react-intl';
import { postJson, API_URL } from '../../../helpers/api/api';

const ImportButton: React.FC<any> = (props: any) => {
  const { projectId, payments } = props;
  const [state, setState] = useState({ loading: false });

  async function handleSave() {
    setState({ loading: true });
    try {
      const { push } = props;
      await postJson(`${API_URL}/projects/${projectId}/imports/payments/confirm`, {
        payments,
      });
      message.success(`import payments successfully.`);
      setState({ loading: false });
      push('/import/payments');
    } catch (err) {
      setState({ loading: false });
      message.warning(`${err}`);
    }
  }
  return (
    <div>
      <Button
        type="primary"
        onClick={handleSave}
        style={{ width: '120px' }}
        loading={state.loading}
      >
        <FormattedMessage id="import.payments.confirmImport" />
      </Button>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  projectId: state.user.currentProjectId,
});

export default connect(mapStateToProps, { push })(ImportButton);
